function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "payment-unfulfilled");

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFEA8A",
  cx: 16,
  cy: 16,
  r: 16
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFF",
  cx: 16,
  cy: 16,
  r: 9
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#9C6F19"
}, React.createElement("path", {
  d: "M17.988 25.78c-.552 0-1-.446-1-1-.002-.468.324-.874.78-.976.876-.198 1.71-.543 2.47-1.02.03-.018.06-.035.09-.05.494-.247 1.095-.048 1.342.446.234.466.07 1.034-.377 1.304-.95.594-1.99 1.024-3.083 1.272-.073.016-.147.024-.222.024zM13.986 25.772c-.076 0-.15-.008-.225-.025-1.095-.252-2.14-.686-3.09-1.285-.464-.3-.596-.92-.295-1.383.295-.455.898-.592 1.36-.31.76.48 1.598.828 2.475 1.03.538.125.873.663.747 1.2-.105.453-.507.773-.97.774v-.002zM23.612 21.805c-.552 0-1-.45-1-1 0-.19.055-.374.155-.533.48-.76.83-1.596 1.033-2.472.124-.538.66-.874 1.2-.75.537.124.873.66.75 1.2-.253 1.094-.688 2.14-1.286 3.09-.185.292-.507.468-.852.465zM8.368 21.777c-.342 0-.66-.175-.84-.465l-.018-.028c-.59-.945-1.016-1.98-1.263-3.067-.113-.54.234-1.07.775-1.183.527-.11 1.047.217 1.175.74.2.873.543 1.706 1.02 2.465.296.465.16 1.083-.306 1.38-.16.103-.35.158-.542.157zM24.78 15.018c-.466 0-.87-.324-.973-.78-.2-.877-.546-1.715-1.023-2.478-.294-.47-.156-1.09.31-1.39.46-.295 1.073-.162 1.37.298v.003l.022.035c.594.953 1.024 2 1.27 3.095.125.538-.21 1.075-.75 1.2h-.003c-.073.014-.148.02-.222.018zM7.228 14.992c-.077 0-.153-.008-.228-.026-.538-.123-.875-.66-.753-1.197v-.004c.252-1.095.684-2.14 1.28-3.093.295-.47.913-.612 1.383-.32.47.295.612.913.318 1.383-.48.763-.827 1.6-1.028 2.48-.104.453-.507.775-.972.776zM20.786 9.377c-.188 0-.372-.053-.53-.154-.763-.478-1.6-.824-2.477-1.023-.543-.105-.898-.63-.793-1.172.105-.542.63-.897 1.172-.792l.063.014c1.098.248 2.146.68 3.1 1.28.468.293.61.91.315 1.378-.183.292-.503.47-.847.468h-.004zM11.224 9.37c-.34.002-.657-.17-.843-.454-.298-.455-.174-1.066.278-1.37.04-.026.082-.05.125-.073.922-.572 1.933-.986 2.992-1.224.54-.124 1.075.213 1.198.752.123.54-.214 1.075-.753 1.198-.87.2-1.703.544-2.46 1.018-.16.1-.347.153-.536.152z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/pending.0a7f3761.svg";
export { SvgComponent as ReactComponent };